// WIN Chat App diagnostic logger -- thin wrapper around shared app_logger.
//
// Usage unchanged:
//   import { logError, logEvent, logWarn, logInfo } from "../chat_logger"

import { createLogger } from "./app_logger"
import db from "./chat_db"

const logger = createLogger(db, "app_log")

export const logError   = logger.logError
export const logWarn    = logger.logWarn
export const logInfo    = logger.logInfo
export const logEvent   = logger.logEvent
export const purgeOldLogs = logger.purgeOldLogs
export const installGlobalErrorHandlers = logger.installGlobalErrorHandlers
